
export default function submit(values, dispatch, props) {
    const { firstName, lastName, email, password, sendEmails } = values;
    props.editUser(firstName, lastName, email, password, !!sendEmails);
};


// WEBPACK FOOTER //
// ./src/components/Account/Edit/submit.js